import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomer, removeCustomer } from 'slice/customerSlice';
import AdminTable from 'common/AdminTable';
import DateFilter from 'common/DateFilter';
import { Link } from 'react-router-dom';

const ListCustomer = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.customer);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const filterColumns = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Mobile', accessor: 'mobile' },
    { Header: 'Address', accessor: 'address' },
  ];

  const tableHeaders = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Mobile', accessor: 'mobile' },
    { Header: 'Address', accessor: 'address' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <Link className="btn btn-success mx-2" to={`/customer/update/${row.original.id}`}>
            Edit
          </Link>
          <button className="btn removebtn mx-2" onClick={() => dispatch(removeCustomer(row.original.id))}>
            Remove
          </button>
        </>
      )
    }
  ];

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Customer List</h4>
      </div>

      {loading && <p className="text-white">Loading...</p>}
      {error && <p className="text-danger">{error}</p>}
      {!loading && data?.length > 0 && (
        <>
          <DateFilter
            data={data}
            dateField="createdAt"
            title="Customers Report"
            columns={filterColumns}
            onFilteredData={setFilteredCustomers}
          />
          <AdminTable tableHeaders={tableHeaders} tableData={filteredCustomers} />
        </>
      )}
      {!loading && (!data || data.length === 0) && <p className="text-white">No customers found.</p>}
    </div>
  );
};

export default ListCustomer;
